(() => {
 'use strict';
 const labels=window.FultonsAboveFoldLabels;
 if(!labels)return;
 const productIdFor=root=>String(root.dataset.productId||root.querySelector('[data-gallery-product-id]')?.dataset.galleryProductId||window.FultonsPriceTrial?.productId||'');
 const bontempiDesktopIds=new Set(["15883521163647", "15883559010687", "15883559043455", "15887240331647", "15887240855935", "15887241019775", "15887270379903", "15887240561023", "15887240626559", "15887241216383", "15887241511295", "15887242166655", "15887271756159", "15887241380223", "15887241773439"]);
 const priceStates=new WeakMap();
 const capturePrice=host=>({host,nodes:[host,...host.querySelectorAll('*')].map(el=>({el,children:[...el.childNodes],className:el.getAttribute('class')})),texts:[...host.querySelectorAll('*')].flatMap(el=>[...el.childNodes]).concat([...host.childNodes]).filter(n=>n.nodeType===Node.TEXT_NODE).map(n=>[n,n.textContent])});
 function restorePrice(root){const state=priceStates.get(root);if(state&&state.host.isConnected&&state.host.contains(state.row)){for(const n of [...state.nodes].reverse()){n.el.replaceChildren(...n.children);if(n.className===null)n.el.removeAttribute('class');else n.el.setAttribute('class',n.className);}for(const[n,text]of state.texts)n.textContent=text;}priceStates.delete(root);root.classList.remove('fap-ready','fap-has-selected-headline');}
 const mobile=matchMedia('(max-width:999px)');
 const amount=node=>Number(node?.textContent.match(/£\s*([\d,]+(?:\.\d+)?)/)?.[1].replaceAll(',','')||0);
 const make=(tag,cls,text)=>{const el=document.createElement(tag);el.className=cls;if(text)el.textContent=text;return el;};
 const removeEverydayPercent=root=>{if(document.documentElement.dataset.fultonsSaleEvent==='true'||document.body.dataset.fultonsSaleEvent==='true')return;root.querySelectorAll('.fap-percent,.fuc-discount,.ftm-discount,.fultons-ethnicraft-price-discount').forEach(node=>node.remove());};
 function price(root){
  const top=root.querySelector('.fultons-product-info>.fultons-retail-price');
  if(!top)return;
  const selected=top.querySelector('.fultons-selected-price');
  const host=selected||top;
  let row=host.querySelector(':scope>.fap-price-row');
  const state=!row?capturePrice(host):null;
  let sale=host.querySelector('.fultons-selected-price__sale,.fap-sale,.fuc-result>strong')||[...host.children].find(n=>n.tagName==='SPAN'&&!n.children.length&&/^(?:From\s+)?£[\d,]+(?:\.\d+)?$/.test(n.textContent.trim()));
  if(!sale){const text=[...host.childNodes].find(n=>n.nodeType===Node.TEXT_NODE&&/£/.test(n.textContent));if(text){sale=make('span','fap-sale',text.textContent.trim());text.replaceWith(sale);}}
  if(!sale)return;
  if(!row){row=make('span','fap-price-row');host.prepend(row);state.row=row;priceStates.set(root,state);}
  sale.classList.add('fap-sale');
  const trimmed=sale.textContent.replace(/^Fultons price\s+/i,'').replace(/^From\s+(?=Reference price\b)/i,'');if(sale.textContent!==trimmed)sale.textContent=trimmed;
  if(sale.parentElement!==row)row.append(sale);
  const reference=host.querySelector('.fultons-selected-price__rrp,.fultons-menu-guide-rrp,.fap-reference,.fuc-rrp');
  if(reference){reference.classList.add('fap-reference');if(reference.parentElement!==row)row.append(reference);}
 let percent=host.querySelector('.fultons-ethnicraft-price-discount,.fap-percent,.fuc-discount');
  const selling=amount(sale),rrp=amount(reference),discount=rrp>selling&&selling>0?Math.round((rrp-selling)/rrp*100):0;
  // Percentage badges are campaign artwork. Keep the everyday selling and
  // reference prices visible, but require an explicit sale-event switch before
  // rendering the red tag. The switch can be set deliberately on <html> or
  // <body> for a verified campaign and removed without changing price data.
  const saleEventActive=document.documentElement.dataset.fultonsSaleEvent==='true'||document.body.dataset.fultonsSaleEvent==='true';
  if(saleEventActive&&discount>0){if(!percent){percent=make('span','fap-percent');row.append(percent);}percent.classList.add('fap-percent');const text='−'+discount+'%';if(percent.textContent!==text)percent.textContent=text;if(percent.parentElement!==row)row.append(percent);}
  else if(percent)percent.remove();
  const category=[...host.children].find(node=>!node.children.length&&/^(?:Fabric|Leather|Upholstery) (?:category|cat) \S+$/i.test(node.textContent.trim()));
  host.classList.toggle('fap-inline-category',Boolean(category));
  if(category){category.classList.add('fap-price-category');const short=category.textContent.replace(/\bcategory\b/i,'cat');if(category.textContent!==short)category.textContent=short;}
 const exact=root.querySelector('.fce[data-selected-sku]');
 root.classList.toggle('fap-has-selected-headline',!!(exact?.dataset.selectedSku&&Math.abs(Number(exact.dataset.selectedPrice)-selling)<0.01));
 }
 function compactDescription(root){
  if(root.dataset.fcdReady==='true'){window.FultonsProductSupport?.intro(root);return;}
  const description=root.querySelector('.catalogue-proof__description,.pdp-refined__intro');if(!description)return;
  const children=[...description.children].filter(node=>!node.matches('.fap-dimension-source,.fap-sofa-dimension-copy,.fap-description-toggle,.fap-description-preview'));
  const lead=children.find(node=>node.matches('p'))||children[0];if(!lead)return;
  lead.classList.add('fap-description-lead');
  children.forEach(node=>node.classList.toggle('fap-description-extra',node!==lead));
  if(!description.id)description.id='FultonsProductDescription-'+String(root.dataset.productId||window.FultonsPriceTrial?.productId||'current');
  let preview=description.querySelector(':scope>.fap-description-preview');
  if(!preview){preview=make('p','fap-description-preview');preview.append(make('span','fap-description-excerpt'));description.prepend(preview);delete description.dataset.fapPreviewKey;}
  let toggle=description.querySelector('.fap-description-toggle');
  if(!toggle){
   toggle=make('button','fap-description-toggle','Read more');toggle.type='button';toggle.setAttribute('aria-controls',description.id);
   toggle.addEventListener('click',()=>{description.dataset.fapExpanded=String(description.dataset.fapExpanded!=='true');compactDescription(root);toggle.focus({preventScroll:true});});
  }
  description.classList.add('fap-description-ready','fap-description-inline');
  const expanded=description.dataset.fapExpanded==='true';
  description.classList.toggle('fap-description-collapsed',!expanded);
  if(expanded){preview.hidden=true;if(toggle.parentElement!==description||description.lastElementChild!==toggle)description.append(toggle);toggle.hidden=false;if(toggle.textContent!=='Read less')toggle.textContent='Read less';toggle.setAttribute('aria-expanded','true');return;}
  preview.hidden=false;toggle.hidden=false;if(toggle.textContent!=='Read more')toggle.textContent='Read more';toggle.setAttribute('aria-expanded','false');if(toggle.parentElement!==preview)preview.append(toggle);
  const excerpt=preview.querySelector('.fap-description-excerpt'),text=lead.textContent.trim().replace(/\s+/g,' '),style=getComputedStyle(preview),width=description.clientWidth;
  if(!width)return;
  const key=width+'|'+style.font+'|'+text+'|'+children.length;
  if(description.dataset.fapPreviewKey===key&&excerpt.textContent.trim()){toggle.hidden=description.dataset.fapNeedsToggle==='false';return;}
  description.dataset.fapPreviewKey=key;
  const maxHeight=parseFloat(style.lineHeight)*3+.5;
  excerpt.textContent=text+' ';
  if(preview.getBoundingClientRect().height<=maxHeight&&children.length===1){description.dataset.fapNeedsToggle='false';toggle.hidden=true;return;}
  description.dataset.fapNeedsToggle='true';
  const words=text.split(' ');let low=0,high=words.length;
  while(low<high){const mid=Math.ceil((low+high)/2);excerpt.textContent=words.slice(0,mid).join(' ')+(mid<words.length?'… ':' ');if(preview.getBoundingClientRect().height<=maxHeight)low=mid;else high=mid-1;}
  excerpt.textContent=words.slice(0,low).join(' ')+(low<words.length?'… ':' ');
 }
 function promoteRangePrice(root){
  const top=root.querySelector('.fultons-product-info>.fultons-retail-price');
  if(!top||top.querySelector('.fultons-selected-price:not(.fap-promoted-price)'))return;
  const source=root.querySelector('.fk-price');
  const sale=source?.querySelector('.fultons-selected-price__sale');
  if(!sale)return;
  let promoted=top.querySelector('.fap-promoted-price');
  if(!promoted){promoted=make('span','fultons-selected-price fap-promoted-price');top.replaceChildren(promoted);}
  const nodes=[source.querySelector('.fultons-selected-price__heading'),source.querySelector('.fultons-selected-price__rrp'),sale,source.querySelector('small')].filter(Boolean);
  const signature=nodes.map(node=>node.outerHTML).join('');
  if(promoted.dataset.sourceSignature===signature)return;
  promoted.dataset.sourceSignature=signature;
  promoted.replaceChildren(...nodes.map(node=>node.cloneNode(true)));
  top.classList.remove('fsp-source-heading');
 }
 function promoteSofaPrice(root){
  const top=root.querySelector('.fultons-product-info>.fultons-retail-price');
  const source=root.querySelector('.fultons-layout-options .fuc-result');
  if(!top||!source?.querySelector('strong')||top.querySelector('.fultons-selected-price:not(.fap-promoted-sofa-price)'))return;
  let promoted=top.querySelector('.fap-promoted-sofa-price');
  if(!promoted){promoted=make('span','fultons-selected-price fap-promoted-sofa-price');top.replaceChildren(promoted);}
  const signature=source.innerHTML;
  if(promoted.dataset.sourceSignature!==signature){
   promoted.dataset.sourceSignature=signature;
   const copies=[...source.children].filter(node=>!node.matches('.fuc-selected-heading,.fuc-configuration')).map(node=>node.cloneNode(true));
   promoted.replaceChildren(...copies);
   promoted.querySelector('strong')?.classList.add('fultons-selected-price__sale');
   promoted.querySelector('.fuc-rrp')?.classList.add('fultons-selected-price__rrp');
  }
  top.dataset.upholsterySelected=productIdFor(root);
  top.dataset.sofaPriceOwner='true';
  top.classList.remove('fsp-source-heading');
  root.dataset.sofaPromotedPrice='true';
 }
 function dimensions(root){
  if(root.querySelector('.fap-sofa-dimensions')){root.querySelectorAll('.fap-dimensions').forEach(node=>node.remove());return;}
  const options=root.querySelector('.fultons-furniture-options,.fultons-wood-options,.fce')?.closest('.fultons-layout-options')||root.querySelector('.fultons-layout-options');if(!options)return;
  const source=[...root.querySelectorAll('.fsd[data-stressless-compact] .fsd-drawing,.fcc[data-cattelan-compact] .fcc-size,.fcc[data-cattelan-compact] .fcc-drawing,.fcc[data-cattelan-compact] .sideboard-guide,.fcc.fct-ready .fcc-size,.fcc.fct-ready .fcc-drawing,.fce-drawing,.fce-seating-dimensions,.fultons-product-dimensions,.fultons-bed-options,.fultons-furniture-options__fixed p,.fultons-furniture-options__result p,.fultons-wood-options__fixed-size,.fultons-wood-options__dimensions,.fultons-wood-options__diagram,.ftm-selection-notes')].filter(n=>!n.closest('.fap-dimensions')&&(!n.hidden||n.matches('.fultons-wood-options__fixed-size,.fultons-furniture-options__fixed p'))&&(n.matches('.fcc-size,figure,.fce-seating-dimensions,.fultons-product-dimensions,.fultons-bed-options,.fultons-wood-options__diagram,.fultons-wood-options__dimensions,.ftm-selection-notes')||/^(Size:|Overall dimensions:)/i.test(n.textContent.trim())));
  const extra=[...root.querySelectorAll('.fce-note')].filter(n=>!n.closest('.fap-dimensions')&&!n.hidden&&/^Overall dimensions:/i.test(n.textContent.trim()));source.push(...extra);
  // When a configurator gives selected dimensions, do not also list every size from the product description.
  if(extra.length){for(let i=source.length-1;i>=0;i--){const n=source[i];if(n.matches('.fultons-product-dimensions')&&!n.querySelector('a,img,svg')){n.classList.add('fap-dimension-source');source.splice(i,1);}}}
  const bontempiIds=new Set(["15883604689279", "15883732943231", "15883552948607", "15883552981375", "15883627037055", "15883626873215", "15883626971519", "15883627233663", "15883627331967", "15883627430271", "15883530633599", "15883521163647", "15883559010687", "15883559043455", "15887240331647", "15887240855935", "15887241019775", "15887270379903", "15887240561023", "15887240626559", "15887241216383", "15887241511295", "15887242166655", "15887271756159", "15887241380223", "15887241773439"]),productId=productIdFor(root);
  const compactChairIds=new Set(['15883743297919','15883744379263','15883744674175','15883744969087','15883746279807','15883747230079','15883747623295','15886397047167','15886397112703']);
  if(compactChairIds.has(productId)&&root.querySelector('.fcc[data-cattelan-compact]')){
   // Use the current selected size; retain native prose when it is the only dimension source.
   const selectedSize=source.find(n=>n.matches('.fcc-size')&&/\d/.test(n.textContent)&&/cm\b/i.test(n.textContent));
   const nativeBlocks=[];
   root.querySelectorAll('.catalogue-proof__description>h3').forEach(heading=>{
    if(!/^Dimensions\s*$/i.test(heading.textContent))return;
    const paragraphs=[];let next=heading.nextElementSibling;
    while(next&&!/^H[1-6]$/.test(next.tagName)){if(next.tagName==='P'&&/\d/.test(next.textContent)&&/cm\b/i.test(next.textContent))paragraphs.push(next);next=next.nextElementSibling;}
    if(paragraphs.length){nativeBlocks.push(...paragraphs);heading.classList.add('fap-dimension-source');paragraphs.forEach(n=>n.classList.add('fap-dimension-source'));}
   });
   for(let n=source.length-1;n>=0;n--){
    if(source[n].matches('.fcc-size')&&!selectedSize)source.splice(n,1);
    else if(selectedSize&&source[n].matches('.fultons-product-dimensions')){source[n].classList.add('fap-dimension-source');source.splice(n,1);}
   }
   if(!selectedSize&&!source.some(n=>n.matches('.fultons-product-dimensions')&&/\d/.test(n.textContent)))source.push(...nativeBlocks);
  }
  const compactStorageIds=new Set(['15883553177983','15883553374591','15883553571199','15883553702271','15883553898879','15883554226559']);
  if(compactStorageIds.has(productId)&&root.querySelector('.fcc[data-cattelan-compact][data-selected-option]')){
   // Keep the current drawing and its dimension caption; omit an identical repeated selected-size line.
   const triple=text=>text.match(/\d+(?:\.\d+)?\s*[×x]\s*\d+(?:\.\d+)?\s*[×x]\s*\d+(?:\.\d+)?/i)?.[0].replace(/\s/g,'').replace(/x/gi,'×');
   const current=source.find(n=>n.matches('.fcc-size')),guide=source.find(n=>n.matches('.sideboard-guide'));
   if(current&&guide&&triple(current.textContent)&&triple(current.textContent)===triple(guide.querySelector('figcaption')?.textContent||'')){
    current.classList.add('fap-dimension-source');source.splice(source.indexOf(current),1);
   }
  }
  if(bontempiIds.has(productId)&&!root.querySelector('.fbfp-mirror-dimensions')){
   const range=root.querySelector('.fultons-bontempi-range .fk-size summary span');
   const bach=root.querySelector('.fbfp-bach .bach-size-field summary span');
   const selected=root.querySelector('#FultonsOtherExactChoice')?.selectedOptions?.[0]?.textContent||'';
   const label=(range?.firstChild?.textContent||bach?.firstChild?.textContent||selected).split(/\s[—–]\s/)[0].trim();
   if(/\d/.test(label)&&/cm\b/i.test(label))source.unshift(make('p','fap-bontempi-size','Overall dimensions: '+label));
   const sourceHold={"15883521163647": "For the 145 cm Bach console, retained source height is 75 cm and the public source states 74.5 cm. Confirm before installation.", "15883559043455": "Nominal depth 50 cm; technical drawing depth 50.5 cm.", "15887270379903": "Retained source width 90 cm versus public width 95 cm. Confirm overall dimensions before installation."};if(sourceHold[productId])source.push(make('p','fap-bontempi-source-hold',sourceHold[productId]));
   root.querySelectorAll('.bach-drawing,.sideboard-guide').forEach(n=>{if(!n.closest('.fap-dimensions'))source.push(n);});
  }

  let box=root.querySelector('.fap-dimensions');
  if(!source.length){if(box)box.hidden=true;return;}
  if(!box){box=make('details','fap-dimensions');box.append(make('summary','',labels.dimensions),make('div','fap-dimensions-content'));options.after(box);}
  box.hidden=false;
  const signature=source.map(n=>n.outerHTML.replace(/ fap-dimension-source/g,'').replace(/fap-dimension-source /g,'')).join('');
  if(box.dataset.sourceSignature===signature)return;
  box.dataset.sourceSignature=signature;
  const content=box.lastElementChild;
  const selectedOverall=source.find(n=>/^Overall dimensions: \d/i.test(n.textContent.trim()))?.textContent.replace(/^Overall dimensions:\s*/,'').trim();
  content.replaceChildren(...source.map(n=>{n.classList.add('fap-dimension-source');const copy=n.cloneNode(true);copy.classList.remove('fap-dimension-source');copy.removeAttribute('id');copy.removeAttribute('hidden');copy.removeAttribute('aria-live');copy.removeAttribute('aria-labelledby');copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));copy.querySelectorAll('button,input,select,textarea,form,summary').forEach(el=>el.remove());if(copy.tagName==='DETAILS'&&copy.classList.contains('fultons-product-dimensions')){copy.open=true;copy.setAttribute('role','group');}if(copy.classList.contains('sideboard-guide'))copy.querySelectorAll('dialog').forEach(el=>el.remove());copy.querySelectorAll('[tabindex],[contenteditable],[aria-live],[aria-controls]').forEach(el=>{for(const a of ['tabindex','contenteditable','aria-live','aria-controls'])el.removeAttribute(a);});if(copy.classList.contains('fultons-bed-options')){copy.classList.replace('fultons-bed-options','fap-bed-drawings');copy.querySelectorAll('.fultons-bed-options__price,.fultons-bed-options__detail,.fultons-bed-options__note').forEach(el=>el.remove());if(selectedOverall)copy.querySelectorAll('.fultons-bed-options__row').forEach(row=>{if(!row.textContent.includes(selectedOverall))row.remove();else row.querySelectorAll('div').forEach(el=>el.remove());});}return copy;}));
 }
 function sofa(root,id){
  const portentoHeadline=root.querySelector('.fultons-product-info>.fultons-retail-price[data-portento-selected="true"]');
  if(root.dataset.portentoConfigured==='true'&&portentoHeadline?.querySelector('.fultons-selected-price')){
   root.dataset.sofaCompact='true';
   portentoHeadline.dataset.sofaPriceOwner='true';
   return;
  }
  const panel=root.querySelector('.fultons-sofa-options[data-category-configurator="true"] .fultons-upholstery-configurator');
  const headline=root.querySelector('.fultons-product-info>.fultons-retail-price[data-upholstery-selected="'+id+'"]');
  if(!panel||!headline?.querySelector('.fultons-selected-price')){delete root.dataset.sofaCompact;return;}
  root.dataset.sofaCompact='true';
  headline.dataset.sofaPriceOwner='true';
  // Remove only the redundant standalone headline VAT prefix; retain category and price-basis copy.
  headline.querySelectorAll('.fultons-selected-price>span').forEach(node=>{if(node.children.length)return;const text=node.textContent.replace(/^Including VAT(?:\s*·\s*|$)/i,'');if(text!==node.textContent){if(text)node.textContent=text;else node.remove();}});
  if(headline.querySelector('.fuc-fabric-range')){
   const namedCategories=new Set([...headline.querySelectorAll('.fuc-fabric-range')].map(node=>node.textContent.split('·').pop().trim().toLowerCase()));
   headline.querySelectorAll('.fultons-selected-price>span').forEach(node=>{if(node.children.length||node.classList.contains('fuc-fabric-range'))return;const text=node.textContent.trim();if(/^(?:Fabric|Leather|Upholstery) (?:category|cat) \S+$/i.test(text)&&namedCategories.has(text.toLowerCase().replace(/\bcat\b/,'category')))node.remove();});
  }
  const library=root.querySelector('.fultons-finishes');
  if(panel.dataset.duresta==='true'&&library?.querySelector('.fultons-finishes__range-select')){
   if(!panel.contains(library))panel.insertBefore(library,panel.querySelector('.fuc-enquire'));
   root.dataset.sofaLibraryIntegrated='true';
  }
  // Keep Duresta's original polite price announcement; only its visual duplicate is clipped by CSS.
  const visual=root.querySelector('.fuc-drawing');
  if(visual&&!visual.hidden){
   let box=visual.closest('.fap-sofa-dimensions');
   if(!box){box=make('details','fap-sofa-dimensions');box.append(make('summary','',labels.dimensions));visual.before(box);box.append(visual);}
   const description=root.querySelector('.catalogue-proof__description');
   if(description)description.querySelectorAll(':scope>p').forEach(paragraph=>{const link=paragraph.querySelector('a[href]');if(/^Dimensions\s*:/i.test(paragraph.textContent.trim())||link&&/dimension|size/i.test((link.getAttribute('href')||'')+' '+link.textContent)){paragraph.classList.add('fap-sofa-dimension-copy');if(paragraph.parentElement!==box)box.append(paragraph);}});
   const visibleFields=[...panel.querySelectorAll(':scope>.fuc-field,:scope>.fuc-coverings,:scope>.fuc-finish-picker')].filter(field=>!field.hidden);
   const anchor=visibleFields.at(-1);
   if(anchor&&!box.closest('[data-fcd-support]')&&anchor.nextElementSibling!==box)anchor.after(box);
   if(!box.dataset.initialized){box.dataset.initialized='true';box.open=false;}
  }
 }
 // Presentation only: supplier controls retain their original option values and event owners.
 function compactFurnitureOptions(root){
  const headline=root.querySelector('.fultons-product-info>.fultons-retail-price');
  if(headline){
   const textNodes=document.createTreeWalker(headline,NodeFilter.SHOW_TEXT);let node;
   while(node=textNodes.nextNode()){const value=node.textContent.replace(/^From\s+(?=Reference price\b)/i,'');if(value!==node.textContent)node.textContent=value;}
  }
  const heading=window.FultonsUpholsteryPickerLabels?.designHeading||'Choose your design';
  const shortLabel=text=>String(text||'').trim().replace(/^\d+\.\s*/,'').replace(/^Choose (?:your |a )?/i,'Select ').replace(/model or size/i,'model and size');
  root.querySelectorAll('.fultons-bontempi-range').forEach(panel=>{
   const summary=panel.querySelector(':scope>summary');if(!summary)return;
   const outer=panel.parentElement.closest('.fultons-layout-options');
   const nested=!!outer?.querySelector(':scope>summary');
   summary.classList.toggle('fap-nested-options-title',nested);
   if(nested){if(!panel.open)panel.open=true;}
   else if(!summary.children.length&&summary.textContent!==heading)summary.textContent=heading;
  });
  root.querySelectorAll('.fultons-layout-options .fce>h2').forEach(title=>{
   const outer=title.closest('.fultons-layout-options');
   title.classList.toggle('fap-nested-options-title',!!outer?.querySelector(':scope>summary'));
  });
  const portento=root.querySelector('#FultonsPortentoConfigurator');
  if(portento){
   const drawing=portento.querySelector('.fp-drawing'),coverings=portento.querySelector('#PortentoCoverings');
   if(drawing&&coverings){
    let box=portento.querySelector('.fap-sofa-dimensions');
    if(!box){box=make('details','fap-sofa-dimensions fap-portento-dimensions');box.append(make('summary','',labels.dimensions));coverings.after(box);}
    for(const node of [portento.querySelector('.fp-selected-dimensions'),drawing,portento.querySelector('#PortentoPhotoNote')])if(node&&node.parentElement!==box)box.append(node);
   }
  }
  // Keep original controls and selected-value nodes; only add presentation labels.
  const captions='.pcf-control>.pcf-label,.fk-field>.fk-label,.fbfp .fbfp-label,.other-exact>label,.fce-label,.fcc-label,.fcc-cover-picker>label,.fcs-picker>label,.fsd-field>label,.fn-table-label,.fct-field>.fct-label';
  root.querySelectorAll(captions).forEach(caption=>{
   if(caption.hidden||caption.closest('.fup,.fcc-chair-covering,.fsd-covering,.fcs-upholstery-picker'))return;
   const host=caption.parentElement,control=caption.htmlFor?document.getElementById(caption.htmlFor):null;
   const shared=control?.closest('.fs-picker');
   if(shared){
    const shell=shared.closest('.fap-native-select-shell');
    if(shell){
     shell.querySelectorAll(':scope>.fap-native-select-copy').forEach(copy=>copy.remove());
     if(shell.children.length===1&&shell.firstElementChild===shared)shell.replaceWith(shared);
    }
   }
   const next=control?.nextElementSibling;
   const picker=shared||(next?.matches('.fce-picker,.fcs-picker,.fultons-visual-choice')?next:host.querySelector(':scope>.pcf-picker,:scope>.fk-choice,:scope>.fultons-visual-choice,:scope>.fce-picker,:scope>.fcc-cover-trigger,:scope>.fsd-trigger,:scope>.fcs-trigger'));
   const trigger=picker?.matches('button')?picker:picker?.querySelector(':scope>summary,:scope>.fcs-trigger,:scope>.fs-picker__toggle');
   if(trigger?.querySelector('.fcc-choice-copy,.fsd-choice-copy,.fcs-choice-copy,.fuc-picker-copy'))return;
   let value=trigger&&[...trigger.children].find(node=>node.tagName==='SPAN'&&!node.matches('.fce-model-artwork,.fce-picker-arrow,.fcc-cover-thumb,.fcc-cover-arrow,.fsd-thumb,.fsd-arrow,.fcs-thumb,.fcs-arrow'));
   if(trigger&&!value){const texts=[...trigger.childNodes].filter(node=>node.nodeType===Node.TEXT_NODE&&node.textContent.trim());if(texts.length){value=make('span','');trigger.append(value);value.append(...texts);}}
   const title=shortLabel(caption.textContent);
   if(shared&&trigger){
    const selected=control.selectedOptions[0]?.textContent?.trim()||'';
    const accessible=[title,selected].filter(Boolean).join(': ');
    if(trigger.getAttribute('aria-label')!==accessible)trigger.setAttribute('aria-label',accessible);
    trigger.removeAttribute('aria-labelledby');
   }
   let native=false;
   if(!value&&control?.tagName==='SELECT'&&!control.hidden){
    let shell=control.parentElement;
    if(!shell.classList.contains('fap-native-select-shell')){shell=make('div','fap-native-select-shell');control.before(shell);shell.append(control);}
    let copy=shell.querySelector(':scope>.fap-native-select-copy');
    if(!copy){copy=make('span','fap-native-select-copy');copy.setAttribute('aria-hidden','true');shell.append(copy);}
    const selected=control.selectedOptions[0]?.textContent||'';
    if(copy.textContent!==selected)copy.textContent=selected;
    if(copy.dataset.fapControlLabel!==title)copy.dataset.fapControlLabel=title;
    native=true;
   }
   caption.classList.toggle('fap-control-caption-source',!!value||native);
   caption.classList.remove('fap-native-control-caption');
   if(!value)return;
   picker.classList.add('fap-labelled-picker');trigger.classList.add('fap-labelled-trigger');
   if(value.dataset.fapControlLabel!==title)value.dataset.fapControlLabel=title;
  });
  root.querySelectorAll('.fcc-drawing').forEach(drawing=>{
   const image=drawing.querySelector('img');
   const hasSource=!!(image?.getAttribute('src')?.trim()||image?.getAttribute('srcset')?.trim());
   drawing.classList.toggle('fap-empty-preview',!hasSource);
  });
  root.querySelectorAll('.fcc:not(.fct-ready):not(.fcc-chair):not(.fcc-table):not(.fcc-bed):not(.fcc-mirror)').forEach(panel=>{
   const select=panel.querySelector('#FultonsCattelanOption');
   if(!select||select.options.length!==1)return;
   const label=panel.querySelector('label[for="FultonsCattelanOption"]');
   if(label)label.classList.add('fap-control-caption-source');
   const visual=panel.querySelector(':scope>.fultons-visual-choice'),preview=panel.querySelector(':scope>.ffp-view');
   const redundant=!!(visual&&(visual.hidden||visual.style.display==='none')&&panel.querySelector(':scope>.fultons-single-model'));
   if(preview)preview.classList.toggle('fap-redundant-fixed-preview',redundant);
  });
  // Remove only the instruction sentence; keep the sold-separately / accessory qualification.
  root.querySelectorAll('.porada-options__intro').forEach(note=>{
   const prefix='Choose the model and finish for your piece. ';
   if(note.textContent.startsWith(prefix))note.textContent=note.textContent.slice(prefix.length);
  });
  root.querySelectorAll('.other-exact').forEach(panel=>{
   const select=panel.querySelector('#FultonsOtherExactChoice'),copy=panel.querySelector('.other-exact__selection'),visible=panel.querySelector('.fap-native-select-copy');
   if(!select||!copy||!visible)return;
   const normalized=value=>String(value||'').trim().replace(/\s+/g,' ');
   const selected=normalized(select.selectedOptions[0]?.textContent);
   const duplicate=!!selected&&normalized(copy.textContent)===selected&&normalized(visible.textContent)===selected;
   copy.classList.toggle('fap-control-caption-source',duplicate);
   if(duplicate)root.querySelectorAll('.fultons-product-options__note').forEach(note=>{
    if(normalized(note.textContent)==='Choose your size and finish below.')note.hidden=true;
   });
  });
  if(root.querySelector('.other-exact__price')){
   const top=root.querySelector('.fultons-product-info>.fultons-retail-price .fultons-selected-price');
   const sale=top?.querySelector('.fultons-selected-price__sale,.fap-sale');
   root.querySelectorAll('.other-exact__price').forEach(copy=>{
    const duplicate=!!sale&&amount(sale)>0&&amount(copy.querySelector('.fultons-selected-price__sale')||copy)===amount(sale);
    copy.classList.toggle('fap-duplicate-option-price',duplicate);
   });
  }
 }
 function settleOptions(root){
  const reservation=root.querySelector('.fultons-product-info>.fap-options-reservation');
  if(!reservation||root.dataset.fapOptionsReady==='true'||root.dataset.fapOptionsPending==='true')return;
  const panel=root.querySelector('.fultons-product-info>.fultons-layout-options');if(!panel)return;
  root.dataset.fapOptionsPending='true';let last=-1,stable=0,frames=0;
  const check=()=>{if(!reservation.isConnected||!panel.isConnected){delete root.dataset.fapOptionsPending;return;}const height=Math.ceil(panel.getBoundingClientRect().height);frames++;if(height>44&&height===last)stable++;else stable=0;last=height;if(stable>=2||frames>=12){root.dataset.fapOptionsReady='true';delete root.dataset.fapOptionsPending;return;}requestAnimationFrame(check);};
  requestAnimationFrame(check);
 }
 function run(){document.querySelectorAll('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])').forEach(root=>{sofa(root,productIdFor(root));promoteRangePrice(root);promoteSofaPrice(root);compactFurnitureOptions(root);dimensions(root);if(!mobile.matches){compactDescription(root);const id=productIdFor(root),selected=!!(root.querySelector('.fultons-product-info>.fultons-retail-price .fultons-selected-price')||root.querySelector('.fultons-retail-price[data-sofa-price-owner="true"] .fultons-selected-price')||root.querySelector('.cattelan-bed-config')&&root.querySelector('.fultons-retail-price[data-cattelan-bed-selected] .fultons-selected-price')||root.querySelector('.fcc[data-selected-option]')&&root.querySelector('.fultons-retail-price[data-cattelan-selected="true"] .fultons-selected-price')||root.querySelector('.fsd[data-stressless-compact="true"]')&&root.querySelector('.fultons-retail-price[data-seating-selected="true"] .fultons-selected-price')||root.querySelector('.fce[data-calligaris-ready="true"][data-selected-sku]')&&root.querySelector('.fultons-retail-price[data-calligaris-selected="true"] .fultons-selected-price')||root.dataset.bontempiHeadline==='true'&&root.querySelector('.fultons-retail-price[data-bontempi-selected="true"] .fultons-selected-price'));root.toggleAttribute('data-selected-desktop-price',selected);if(bontempiDesktopIds.has(id)||selected){if(bontempiDesktopIds.has(id))root.dataset.bontempiCompactPrice='true';price(root);}else restorePrice(root);removeEverydayPercent(root);return;}root.classList.add('fap-ready');price(root);settleOptions(root);compactDescription(root);removeEverydayPercent(root);});}
 let queued=false;
 const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;observer.disconnect();try{run();}finally{const target=document.getElementById('MainContent')||document.body;if(target)observer.observe(target,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-selected-sku','data-selected-price','hidden','src']});}});};
 const observer=new MutationObserver(schedule);
 {const target=document.getElementById('MainContent')||document.body;if(target)observer.observe(target,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-selected-sku','data-selected-price','hidden','src']});}
 document.addEventListener('fultons:catalogue-updated',schedule);document.addEventListener('change',schedule);document.addEventListener('shopify:section:load',schedule);mobile.addEventListener('change',schedule);window.addEventListener('resize',schedule);document.fonts?.ready.then(schedule);schedule();
})();

(() => {
  'use strict';
  if (window.FultonsProductSupport) return;
  const roots = '.catalogue-proof,.pdp-refined,.fultons-online-product';
  const labels = ['Description', 'Dimensions', 'Specifications', 'Care & Buying Guide', 'Delivery & Returns'];
  const states = new WeakMap();
  let sequence = 0;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const ownerFor = (root, info) => [...root.querySelectorAll('#FultonsPortentoConfigurator [data-portento-interface],.fultons-upholstery-configurator,.fsd[data-stressless-recliner="true"],.stressless-offer-options,.stressless-office-options')].find(node => !node.closest('[data-fcd-region]')) || info;
  const sectionFor = text => /^(?:dimensions?|sizes?|measurements?)(?:\s|:|$)/i.test(text) ? 1 : /^(?:specifications?|materials?|features?|finishes)(?:\s|:|$)/i.test(text) ? 2 : /^(?:care|buying|delivery access)(?:\s|:|$)/i.test(text) ? 3 : /^(?:delivery|returns?|payments?)(?:\s|:|$)/i.test(text) ? 4 : 0;
  const revealEnquiry = root => {
    const holder = root?.querySelector('#FultonsEnquiry');
    if (!holder) return false;
    holder.hidden = false;
    holder.dataset.fcdRequested = 'true';
    holder.closest('details')?.setAttribute('open', '');
    return true;
  };
  const openAncestors = node => {
    for (let parent = node?.parentElement; parent; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
  };
  const stateFor = (root, info) => {
    let state = states.get(root);
    if (state) return state;
    const block = make('div', 'fcd-support');
    block.dataset.fcdSupport = '';
    const sections = labels.map((label, index) => {
      const details = make('details', 'fcd-section');
      details.dataset.fcdSection = String(index);
      details.append(make('summary', 'fcd-summary', label), make('div', 'fcd-body'));
      block.append(details);
      return details;
    });
    state = { block, sections, bodies: sections.map(node => node.lastElementChild), mirrors: new Map() };
    const product = String(root.dataset.productId || root.querySelector('[data-gallery-product-id]')?.dataset.galleryProductId || 'product').replace(/[^\w-]/g, '');
    sections[0].id = 'FultonsFullDescription-' + product + '-' + (++sequence);
    states.set(root, state);
    root.dataset.fcdReady = 'true';
    return state;
  };
  const place = (root, info, state) => {
    const owner = ownerFor(root, info), grid = root.querySelector('.catalogue-proof__grid,.pdp-refined__grid,.fultons-online-product__grid');
    const desktop = matchMedia('(min-width:1000px)').matches && grid;
    let parent = owner;
    if (desktop) {
      if (!state.region) { state.region = make('div', 'fcd-support-region'); state.region.dataset.fcdRegion = ''; }
      const region = state.region;
      if (region.parentElement !== info || info.lastElementChild !== region) info.append(region);
      const namespaces = ['fultons-portento', 'fultons-upholstery-configurator'];
      const classes = ['fcd-support-region', ...namespaces.filter(name => owner.classList.contains(name) || owner.closest('#FultonsPortentoConfigurator') && name === 'fultons-portento')].join(' ');
      if (region.className !== classes) region.className = classes;
      region.hidden = false; parent = region;
    } else if (state.region) state.region.hidden = true;
    if (state.block.parentElement !== parent || parent.lastElementChild !== state.block) parent.append(state.block);
    const finance = root.querySelector('.fultons-finance-note');
    if (finance && desktop) { if (finance.parentElement !== owner) owner.append(finance); }
    else if (finance && (finance.parentElement !== parent || parent !== info && finance.nextElementSibling !== state.block)) state.block.before(finance);
  };
  const embed = (node, body, flatten = true) => {
    if (!node || body.contains(node)) return;
    if (node.tagName === 'DETAILS' && flatten) {
      node.classList.add('fcd-embedded');
      node.open = true;
    }
    body.append(node);
  };
  const description = (root, state) => {
    const source = root.querySelector('.catalogue-proof__description,.pdp-refined__intro,.fultons-online-product__intro');
    if (!source) return;
    let target = 0;
    for (const node of [...source.childNodes]) {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        if (node.textContent.trim()) state.bodies[target].append(node);
        continue;
      }
      if (node.matches('.fap-description-preview,.fap-description-toggle')) continue;
      if (node.matches('[data-fultons-specifications]')) continue;
      if (/^H[1-6]$/.test(node.tagName)) target = sectionFor(node.textContent.trim());
      if (node.matches('.fap-dimension-source,.fap-sofa-dimension-copy')) target = 1;
      node.classList.remove('fap-description-lead', 'fap-description-extra', 'fap-dimension-source', 'fap-sofa-dimension-copy');
      state.bodies[target].append(node);
    }
    source.classList.add('fcd-description-source');
  };
  const intro = root => {
    const state = states.get(root);
    const source = root.querySelector('.catalogue-proof__description,.pdp-refined__intro,.fultons-online-product__intro');
    if (!state || !source) return;
    const lead = state.bodies[0].querySelector('p') || [...state.bodies[0].childNodes].find(node => node.textContent.trim());
    const text = lead?.textContent.trim().replace(/\s+/g, ' ');
    if (!text) return;
    let preview = source.querySelector(':scope>.fap-description-preview');
    if (!preview) { preview = make('p', 'fap-description-preview'); source.prepend(preview); }
    let excerpt = preview.querySelector('.fap-description-excerpt');
    if (!excerpt) { excerpt = make('span', 'fap-description-excerpt'); preview.prepend(excerpt); }
    let toggle = source.querySelector('.fap-description-toggle');
    if (!toggle?.dataset.fcdReadmore) {
      const previous = toggle;
      toggle = previous ? previous.cloneNode(true) : make('button', 'fap-description-toggle');
      toggle.type = 'button'; toggle.textContent = 'Read more'; toggle.dataset.fcdReadmore = 'true';
      if (previous) previous.replaceWith(toggle);
      preview.append(toggle);
      toggle.addEventListener('click', () => {
        const section = state.sections[0];
        openAncestors(section); section.open = true;
        toggle.setAttribute('aria-expanded', 'true');
        section.querySelector(':scope>summary')?.focus({ preventScroll: true });
        section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      state.sections[0].addEventListener('toggle', () => toggle.setAttribute('aria-expanded', String(state.sections[0].open)));
    }
    if (toggle.parentElement !== preview) preview.append(toggle);
    source.classList.add('fap-description-ready', 'fap-description-inline', 'fap-description-collapsed');
    preview.hidden = false; toggle.hidden = false;
    toggle.setAttribute('aria-controls', state.sections[0].id);
    toggle.setAttribute('aria-expanded', String(state.sections[0].open));
    const style = getComputedStyle(preview), width = source.clientWidth;
    const key = width + '|' + style.font + '|' + text;
    if (state.introKey === key && excerpt.textContent.trim()) return;
    state.introKey = key;
    const words = text.split(' '), lineHeight = parseFloat(style.lineHeight);
    if (!width || !(lineHeight > 0)) {
      const limit = Math.min(words.length, 36);
      excerpt.textContent = words.slice(0, limit).join(' ') + (limit < words.length ? '… ' : ' ');
      return;
    }
    const maxHeight = lineHeight * 3 + .5;
    let low = 0, high = words.length;
    while (low < high) {
      const mid = Math.ceil((low + high) / 2);
      excerpt.textContent = words.slice(0, mid).join(' ') + (mid < words.length ? '… ' : ' ');
      if (preview.getBoundingClientRect().height <= maxHeight) low = mid;
      else high = mid - 1;
    }
    excerpt.textContent = words.slice(0, low).join(' ') + (low < words.length ? '… ' : ' ');
  };
  const onlineDetails = (root, state) => {
    const source = root.querySelector('[data-fcd-online-details]');
    if (!source) return;
    let target = 2;
    const lists = new Map();
    for (const node of [...source.childNodes]) {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        if (node.textContent.trim()) state.bodies[target].append(node);
        continue;
      }
      if (/^H[1-6]$/.test(node.tagName)) target = sectionFor(node.textContent.trim());
      if (node.matches('ul,ol')) {
        for (const item of [...node.children]) {
          const index = /^(?:dimensions?|sizes?|measurements?)(?:\s|:|\()/i.test(item.textContent.trim()) ? 1 : target;
          const key = index + ':' + node.tagName;
          let list = lists.get(key);
          if (!list) { list = node.cloneNode(false); state.bodies[index].append(list); lists.set(key, list); }
          list.append(item);
        }
        node.remove();
      } else state.bodies[target].append(node);
    }
    source.closest('details')?.remove();
  };
  const poradaReferences = (root, state) => {
    for (const section of root.querySelectorAll('.porada-options[data-porada-enhanced="true"]')) {
      const models = [...section.querySelectorAll('.porada-options__model')];
      const reference = (node, body, flatten = false) => {
        const model = node.closest('.porada-options__model');
        if (model) {
          node.dataset.poradaReferenceModel = String(models.indexOf(model));
          node.dataset.poradaReferenceInitialHidden = node.dataset.beforeSoftHidden || String(node.hidden);
          node.hidden = node.hidden || model.hidden;
        }
        embed(node, body, flatten);
      };
      for (const heading of section.querySelectorAll(':scope>h2')) {
        if (heading.id === 'PoradaOptionsTitle' || heading.textContent.trim() !== 'Finish samples') continue;
        const note = heading.nextElementSibling;
        embed(heading, state.bodies[2], false);
        if (note?.matches('p.porada-options__note')) embed(note, state.bodies[2], false);
      }
      embed(section.querySelector(':scope>.porada-options__intro'), state.bodies[2], false);
      section.querySelectorAll('.porada-options__swatches,.porada-options__finish-list').forEach(node => reference(node, state.bodies[2]));
      section.querySelectorAll('.porada-options__drawings').forEach(node => reference(node, state.bodies[1]));
      section.querySelectorAll('.porada-compact-dimensions,.porada-options__dimensions').forEach(node => reference(node, state.bodies[1], true));
    }
  };
  const natuzziConfigurationNotes = (root, state) => {
    const normalized = text => String(text || '').replace(/\s+/g, ' ').trim();
    for (const node of root.querySelectorAll('[data-natuzzi-configuration-note]')) {
      const target = node.dataset.natuzziConfigurationNote;
      if (!['dimensions', 'specifications'].includes(target)) continue;
      const body = state.bodies[target === 'dimensions' ? 1 : 2];
      const text = normalized(node.textContent);
      const duplicate = text && [...body.querySelectorAll('p,li')].some(other => other !== node && !other.hidden && normalized(other.textContent) === text);
      node.hidden = !text || Boolean(duplicate);
      if (node.parentElement !== body) body.append(node);
    }
  };
  const technical = (root, state) => {
    natuzziConfigurationNotes(root, state);
    poradaReferences(root, state);
    root.querySelectorAll('.cattelan-bed-dimensions').forEach(node => embed(node, state.bodies[1]));
    root.querySelectorAll('.fbfp-mirror-dimensions').forEach(node => embed(node, state.bodies[1]));
    if (root.matches('.fultons-online-product')) {
      onlineDetails(root, state);
      root.querySelectorAll('[data-fcd-online-delivery],[data-fcd-online-returns]').forEach(node => embed(node, state.bodies[4]));
      embed(root.querySelector('.fultons-online-product__return-note'), state.bodies[4]);
      const previous = root.querySelector('.fultons-online-product__details');
      if (previous && !previous.children.length) previous.remove();
    }
    root.querySelectorAll('.fap-dimensions,.fap-sofa-dimensions,.fap-stressless-dimensions').forEach(node => embed(node, state.bodies[1]));
    root.querySelectorAll('[data-fultons-specifications]').forEach(node => {
      if (node.closest('.fap-dimensions,.fap-sofa-dimensions,.fap-stressless-dimensions')) return;
      const dimensionSource = node.querySelector('.fultons-specifications__drawing,[href*="dimensions"],table') || /^Dimensions\b/i.test(node.textContent.trim());
      embed(node, state.bodies[dimensionSource ? 1 : 2]);
    });
    for (const [selector, index] of [['#PortentoMatrix', 2], ['#PortentoLibrary', 2], ['#PortentoOriginalDrawings', 1]]) embed(root.querySelector(selector), state.bodies[index], false);
    const finishes = root.querySelector('#FultonsAvailableFinishes');
    if (finishes && root.dataset.sofaLibraryIntegrated !== 'true') embed(finishes, state.bodies[2]);
    const coveringAdvice = root.querySelector('.fp-availability');
    if (coveringAdvice) embed(coveringAdvice, state.bodies[3]);
  };
  const copyTerms = (root, state) => {
    const candidates = [];
    for (const range of ['natuzzi', 'ethnicraft', 'view', 'manual']) {
      const panel = root.querySelector('[data-' + range + '-purchase]');
      const field = panel?.querySelector('[data-' + range + '-delivery]');
      const details = field?.closest('details');
      if (details && field.textContent.trim()) candidates.push([details, 4]);
      const selection = panel?.querySelector('[data-' + range + '-order-summary]')?.closest('details');
      if (selection) candidates.push([selection, 2]);
    }
    const quickship = root.querySelector('.fultons-consul-terms,.fultons-online-purchase .fultons-purchase-terms');
    if (quickship) candidates.push([quickship, 4]);
    const generic = root.querySelector('.fo-estimate-content');
    if (!candidates.some(([, index]) => index === 4) && generic) candidates.push([generic, 4]);
    for (const [source, index] of candidates) {
      let mirror = state.mirrors.get(source);
      if (!mirror) { mirror = make('div', 'fcd-terms-copy'); state.bodies[index].append(mirror); state.mirrors.set(source, mirror); }
      const copy = source.cloneNode(true);
      if (copy.tagName === 'DETAILS') copy.querySelector(':scope>summary')?.remove();
      copy.querySelectorAll('details').forEach(details => { details.querySelector(':scope>summary')?.remove(); details.replaceWith(...details.childNodes); });
      copy.querySelectorAll('form,input,select,textarea,button,dialog,script,template').forEach(node => node.remove());
      for (const node of [copy, ...copy.querySelectorAll('*')]) {
        for (const attribute of [...node.attributes]) if (attribute.name === 'id' || attribute.name.startsWith('data-') || attribute.name.startsWith('aria-')) node.removeAttribute(attribute.name);
        node.className = '';
      }
      const html = copy.innerHTML;
      if (mirror.innerHTML !== html) mirror.innerHTML = html;
      source.classList.add('fcd-terms-source');
    }
    state.mirrors.forEach((mirror, source) => {
      if (!candidates.some(([candidate]) => candidate === source)) { mirror.remove(); source.classList.remove('fcd-terms-source'); state.mirrors.delete(source); }
    });
    const short = root.querySelector('.fultons-natuzzi-purchase__delivery-short,.fultons-ethnicraft-purchase__delivery-short,.fultons-view-purchase__delivery-short,.fultons-manual-purchase__delivery-short,.fultons-consul-delivery');
    const genericDelivery = root.querySelector('.fultons-delivery-note');
    if (genericDelivery) genericDelivery.classList.toggle('fcd-duplicate-delivery', Boolean(short && short.textContent.trim() && !short.closest('[hidden]')));
  };
  const care = (root, state) => {
    const body = state.bodies[3];
    if (body.children.length) return;
    const source = root.querySelector('[data-natuzzi-access-guide],[data-ethnicraft-access-guide],[data-view-access-guide],[data-manual-access-guide]');
    if (source) {
      const paragraph = make('p');
      const link = source.cloneNode(true);
      link.removeAttribute('id');
      [...link.attributes].filter(attribute => attribute.name.startsWith('data-')).forEach(attribute => link.removeAttribute(attribute.name));
      paragraph.append(link); body.append(paragraph);
    }
    if (!body.children.length) body.append(make('p', '', 'Please ask our showroom for care advice.'));
  };
  const run = () => {
    document.querySelectorAll(roots).forEach(root => {
      const info = root.querySelector('.fultons-product-info,.fultons-online-product__information');
      if (!info || !root.querySelector('.catalogue-proof__description,.pdp-refined__intro,.fultons-online-product__intro')) return;
      const state = stateFor(root, info);
      place(root, info, state);
      description(root, state); intro(root); technical(root, state); copyTerms(root, state); care(root, state);
      for (const [index, label] of [[1, 'Please ask our showroom for dimensions.'], [2, 'Please ask our showroom for specifications.'], [4, 'Please ask our showroom about delivery and returns.']]) {
        const body = state.bodies[index];
        let fallback = body.querySelector(':scope>.fcd-fallback');
        const hasContent = [...body.children].some(node => node !== fallback);
        if (hasContent && fallback) fallback.remove();
        if (!hasContent && !fallback) { fallback = make('p', 'fcd-fallback', label); body.append(fallback); }
      }
      const holder = root.querySelector('#FultonsEnquiry');
      if (holder && (holder.querySelector('[data-product-enquiry-result]') || location.hash === '#FultonsEnquiry')) revealEnquiry(root);
    });
  };
  let queued = false;
  const observer = new MutationObserver(() => schedule());
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false; observer.disconnect();
      try { run(); } finally { observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, characterData: true }); }
    });
  };
  document.addEventListener('click', event => {
    const action = event.target.closest?.('#PortentoEnquireButton,.fuc-enquire,.fsd-enquire,.fce-enquire,.fcc-enquire,.porada-options__enquire,.ftm-enquire,[data-stressless-enquire],a[href*="#FultonsEnquiry"],.fo-estimate>summary');
    const root = action?.closest(roots);
    if (!root) return;
    if (action.matches('.fo-estimate>summary')) {
      const section = states.get(root)?.sections[4];
      if (section) { event.preventDefault(); section.open = true; section.scrollIntoView({ block: 'nearest', behavior: 'auto' }); }
      return;
    }
    if (action.tagName === 'A' && !action.hash && action.href) return;
    revealEnquiry(root);
  }, true);
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href^="#"]');
    const root = anchor?.closest(roots);
    if (!root || !anchor.hash) return;
    const target = root.querySelector('[id="' + CSS.escape(decodeURIComponent(anchor.hash.slice(1))) + '"]');
    if (target) { openAncestors(target); if (target.tagName === 'DETAILS') target.open = true; }
  }, true);
  window.addEventListener('hashchange', () => {
    if (location.hash === '#FultonsEnquiry') document.querySelectorAll(roots).forEach(revealEnquiry);
  });
  document.addEventListener('fultons:catalogue-updated', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  window.FultonsProductSupport = Object.freeze({ refresh: schedule, intro });
  schedule();
})();
